import { render, staticRenderFns } from "./main_question_publish.vue?vue&type=template&id=e201f57c&scoped=true&"
import script from "./main_question_publish.vue?vue&type=script&lang=js&"
export * from "./main_question_publish.vue?vue&type=script&lang=js&"
import style0 from "./main_question_publish.vue?vue&type=style&index=0&id=e201f57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e201f57c",
  null
  
)

export default component.exports